import styled from '@emotion/styled/macro';

export const TempTermsWrapper = styled.div`
    margin: 0 auto;
    max-width: 987px;
    padding: ${props => props.theme.spacing.large};

    a,
    a:visited,
    a:hover {
        color: ${props => props.theme.colours.textOrange};
        text-decoration: underline;
    }
`;

export const Title = styled.h1`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.xlarge};
    color: ${props => props.theme.colours.textGreen};
    margin-bottom: ${props => props.theme.spacing.small};
`;

export const SubTitle = styled.h2`
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.large2};
    color: ${props => props.theme.colours.dark};
    margin-bottom: ${props => props.theme.spacing.large};
`;

export const Links = styled.ul`
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.medium};
    margin-bottom: ${props => props.theme.spacing.large};

    & li:first-child {
        padding-bottom: ${props => props.theme.spacing.large};
    }
`;

export const OrderedList = styled.ol`
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.normal};
    line-height: 20px;
    list-style-type: none;
    color: ${props => props.theme.colours.dark};
    counter-reset: item;
    margin: 0;
    padding: 0;

    & > li {
        display: table;
        counter-increment: item;
        font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
        padding: ${props => props.theme.spacing.small};
    }

    & > li:before {
        content: counters(item, '.') '. ';
        display: table-cell;
        padding-right: 0.6em;
    }

    & li ol > li {
        margin: 0;
        font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    }

    & li ol > li:before {
        content: counters(item, '.') ' ';
    }
`;

export const TermsParagraph = styled.div`
    margin-bottom: 12px;
`;

export const TextUnderline = styled.span`
    text-decoration: underline;
`;
